const DEV = import.meta.env.DEV;

export function devLog(...args: unknown[]): void {
  if (DEV) console.log(...args);
}

export function devWarn(...args: unknown[]): void {
  if (DEV) console.warn(...args);
}

export function devError(...args: unknown[]): void {
  if (DEV) console.error(...args);
}
